import script from "./TheSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./TheSelect.vue?vue&type=script&setup=true&lang=js"

import "./TheSelect.vue?vue&type=style&index=0&id=40a404bc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a404bc"]])

export default __exports__